import { useLocation } from "react-router";

/**
 * Returns a helper that appends the current URL query string to a href.
 *
 * The map editor keeps layer visibility and list pagination in the URL query
 * string, so view-switching navigations (list <-> detail <-> tabs) must carry
 * the search along, otherwise all layers are turned back on. `location.search`
 * already starts with "?", so it can be appended as-is.
 *
 * Only use this for view-switching navigation, not for state-changing actions
 * (e.g. after deleting a layer, dropping a stale layerIds is intentional).
 */
export function useWithSearch() {
    const { search } = useLocation();

    return (href: string) => href + search;
}
